import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { KindRootNodeSelect as LocalKindRootNodeSelect } from '../../components/Kind/RootNode/Select'

export const KindRootNodeSelect = connect(
  LocalKindRootNodeSelect,
  mapReadPretty(LocalKindRootNodeSelect, {
    disabled: true
  })
)
